import { SelectContentProps } from 'components/ui/Forms';
import { useAuth } from 'hooks/auth';
import { api } from 'services/api';

export function useVehicleType() {
  const { token } = useAuth();
  const getVehicleTypes = async (): Promise<SelectContentProps[]> => {
    const { data } = await api.get(`/vehicle-types?asList=1`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((vehicleType: any) => ({
      value: vehicleType.id,
      name: vehicleType.name,
    }));
  };

  return { getVehicleTypes };
}
